import getConfig from "next/config";
const {
  publicRuntimeConfig: { settings },
} = getConfig();

export const content = {
  altex: {
    title:
      "Altex, 30 de ani de experienta in sprijinul clientilor si partenerilor nostri",
    image: [
      {
        path: `${settings.websiteStatics}/images/about-us/about-us-mobile.svg`,
        media: "(max-width: 640px)",
        isDefault: false,
      },
      {
        path: `${settings.websiteStatics}/images/about-us/about-us.svg`,
        isDefault: true,
      },
    ],
    content: (
      <>
        <p className="mb-4">
          Altex este unul dintre cele mai bune exemple de antreprenoriat de
          succes din Romania. A pornit ca un business local de import
          televizoare, dar a reusit sa devina liderul pietei romanesti de retail
          electro-IT, in 30 de ani plini de provocari si adaptare continua la
          schimbarile din mediul de afaceri.
        </p>
        <p className="mb-4">
          Reteta Altex? A pus mereu clientul pe primul plan si a construit o
          infrastructura care sa corespunda exigentelor pietei.
        </p>
        <p className="mb-4">
          Inca de la infiintare, compania si-a propus sa ofere produse de
          calitate adecvate dorintelor consumatorilor si solutii de finantare
          acesibile.
        </p>
        <h2 className="text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4">
          Tehnologie accesibila tuturor clientilor
        </h2>
        <p className="mb-4">
          Altex are misiunea de a aduce tehnologia de ultima generatie in casele
          tuturor romanilor, prin produse si servicii care le satisfac nevoile.
          Conceptul omnichannel, a carui implementare a inceput in 2014, aduce
          confort si usurinta in procesul de informare, luare a deciziei,
          interactiune cu produsul, cumparare si apoi utilizare.
        </p>
        <p className="mb-4">
          Ca reprezentanti ai companiei, ne mandrim ca suntem una dintre cele
          mai importante companii private romanesti si{" "}
          <a
            href="https://altex.ro/"
            target="_blank"
            rel="noreferrer"
            className="font-semibold underline"
          >
            liderul pietei de produse electronice, electrocasnice, IT&amp;C
          </a>{" "}
          si multimedia din Romania.
        </p>
        <p className="mb-4">
          Reteaua noastra nationala de magazine (peste 125 magazine Altex) se
          afla in continua expansiune, la fel si gamele de produse pe care le
          comercializam, la cele mai avantajoase preturi. Nu doar deschidem noi
          unitati, in orase mari si medii din toata tara, dar am inceput si un
          amplu proces de reamenajare si modernizare a celor deja existente.
        </p>
        <p className="mb-4">
          Suntem incantati ca putem oferi clientilor nostri o gama variata de
          electrocasnice mici si mari, cosmetice, obiecte de voiaj, articole
          pentru copii si bebelusi, biciclete electrice, masini second hand,
          laptopuri, telefoane, produse software, aparate de aer conditionat,
          jocuri pentru PC si diverse console (cum ar fi PS sau Xbox),
          calculatoare pentru gaming si multe alte produse.
        </p>
        <p className="mb-4">
          Gama de produse este atent gandita, avand ca principal criteriu
          calitatea si performanta produsului.
        </p>
        <h2 className="text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4">
          Solutii de finantare
        </h2>
        <p className="mb-4">
          Pentru clientii nostri, am infiintat{" "}
          <a
            href="https://altex.ro/solutii-finantare/credit-online/"
            target="_blank"
            rel="noreferrer"
            className="font-semibold underline"
          >
            Credex
          </a>
          , o companie de credite de consum, care ii ajuta cu solutii optime de
          finantare, la achizitia produselor din magazinele Altex si de pe
          altex.ro. Solutiile de finantare pe care le-am gandit sunt extrem de
          flexibile si se remarca prin dobanzi si rate mici.
        </p>
        <p className="mb-4">
          Cei peste 4.000 de angajati Altex din magazine, de la sediul central
          din Voluntari si din depozitele de marfa incearca, in fiecare zi, sa
          ofere cele mai bune experiente de interactiune cu brandul.
        </p>
        <p className="mb-4">
          Doar asa putem oferi „cel mai mic pret din Romania” si sustine
          promisiunea de a returna “de 2 x diferenta, daca gasesti in alta parte
          mai ieftin”.
        </p>
        <p className="mb-4">
          Cu ajutorul colegilor din magazine si al produselor expuse, completam
          oferta de pret cu o experienta reala, convingatoare, care sa dea
          clientului increderea ca a facut cea mai buna investitie.
        </p>
      </>
    ),
  },
  mediagalaxy: {
    title: "Profilul companiei Media Galaxy",
    image: [
      {
        path: "https://lcdn.mediagalaxy.ro/LP/ATX/blog/media_galaxy_show_room_1_24160700_df76b461.jpg",
        isDefault: true,
      },
    ],
    content: (
      <>
        <p className="mb-4">
          Media Galaxy reprezinta una dintre cele mai mari retele de magazine cu
          vanzare de produse electronice si electrocasnice ce activeaza pe piata
          romanasca, punand la dispozitia clientilor o gama variata de produse
          atat online, cat si offline, in cele mai mari orase ale tarii:
          Bucuresti, Cluj, Iasi, Arad, Brasov, Constanta, Timisoara, Pitesti,
          Baia Mare, Oradea, Craiova, Targul Mures, Suceava.
        </p>
        <p className="mb-4">
          Media Galaxy este alaturi de clientii sai de 16 ani, de cand a
          inaugurat pe piata din Romania un nou concept: o retea de magazine de
          mare suprafata, care sa ofere cea mai variata gama de produse, sa
          reflecte pasiunea pentru tehnologie si dorinta de a pune la dispozitia
          clientilor cele mai noi device-uri. Spatiile generoase, de peste 3.000
          mp pe magazin, precum si selectia produselor, inseamna in primul rand
          o mare libertate de alegere pentru fiecare client care trece pragul
          magazinelor.
        </p>
        <p className="mb-4">
          Cele 19 magazine de mare suprafata Media Galaxy reflecta pasiunea
          pentru tehnologie si pentru dispozitivele care fac accesibila
          informatia si conexiunea cu ceilalti. Printr-o selectie relevanta de
          branduri, alaturi de servicii de calitate, Media Galaxy aduce
          tehnologia mai aproape de consumatori, facand-o mai accesibila
          devenind o parte fireasca a vietii acestora.
        </p>
        <p className="mb-4">
          <br />
        </p>
        <p className="mb-4"> </p>
        <h2 className="text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4">
          Cea mai variata gama de produse electronice si
          electrocasnice&nbsp;&nbsp;
        </h2>
        <p className="mb-4">
          In magazinele Media Galaxy si pe site-ul mediagalaxy.ro gasesti{" "}
          <a
            href="https://mediagalaxy.ro/promo/"
            target="_blank"
            rel="noreferrer"
            className="font-semibold underline"
          >
            oferte la electrocasnice si electronice
          </a>
          , precum si la categorii noi de produse – articole de voiaj si
          trolere, cosmetice si parfumuri, cafea, sucuri si apa sau articole
          pentru copii si bebelusi. Ai la dispozitie reduceri la cele mai
          cunoscute branduri de televizoare, precum si la o gama larga de
          produse si gadget-uri IT, incepand cu cele mai performante laptopuri
          si ajungand la sisteme PC, software si retelistica. Iti poti comanda
          orice produs de care ai nevoie in gospodarie: frigider, masina de
          spalat, aragaz sau expresor, precum si fiare de calcat, aspiratoare
          sau roboti de bucatarie. Poti descoperi o serie variata de modele de
          camere foto si aparate video, telefoane de ultima generatie si kit-uri
          smart home.{" "}
        </p>
        <p className="mb-4">
          Pentru pasionatii de gaming Media Galaxy ofera o gama variata de
          console gaming – PS4, Xbox si Nintendo, precum si jocurile potrivite
          pentru acestea. Nici zona auto nu ramane mai prejos – la Media Galaxy
          gasesti anvelope, accesorii auto si chiar masini second hand.
        </p>
        <p className="mb-4">
          Media Galaxy ofera consumatorilor cea mai variata gama de produse si o
          selectie importanta de branduri de calitate, iar prin serviciul
          “Rambursam diferenta” primesti diferenta de pret sub forma de voucher
          daca gasesti un pret mai mic in alta parte.
        </p>
        <p className="mb-4">
          <br />
        </p>
        <p className="mb-4"> </p>
        <h2 className="text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4">
          Strategie omnichannel
        </h2>
        <p className="mb-4">
          Media Galaxy pune consumatorul in centrul proceselor de business si
          dezvolta constant strategia omnichannel pentru ca experienta
          cumparatorilor sa fie similara atat in mediul online cat si in mediul
          offline al magazinelor. Media Galaxy traduce printr-o dezvoltare
          omnichannel nevoia de a fi oricand si oriunde este clientul.
        </p>
        <p className="mb-4">
          Inca de la primul magazin aparut pe piata, in Bucuresti Mall Vitan,
          Media Galaxy si-a respectat promisiunea de a aduce cea mai variata
          gama de produse, oferindu-i mereu expertiza pe toate ariile de
          echipamente electronice. De asemenea, ofera servicii precum
          consilierea avizata din partea unor specialisti pregatiti, serviciul
          de livrare, de instalare la cerere sau cel de extragarantie.
        </p>
        <p className="mb-4">&nbsp;</p>
        <h2 className="text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4">
          Servicii de calitate si solutii de finantare&nbsp;
          <br />
        </h2>
        <p className="mb-4">
          Nu-ti face griji pentru buget, fiindca ai la dispozitie metode de
          creditare variate, care iti permit sa cumperi acum de la Media Galaxy
          si sa platesti in timp cumparaturile, fara a le simti la buzunar!
          Beneficiezi de rate fara dobanda prin cardul BRD, precum si variante
          flexibile de rate de la ING, Banca Transilvania, Raiffeisen, Piraeus,
          Alpha Bank, Euroline, Unicredit sau Card Avantaj.
        </p>
        <p className="mb-4">
          De asemenea, poti cumpara rapid si fara acte suplimentare prin
          sistemul de rate Credex.
        </p>
        <p className="mb-4">
          Vino la unul dintre magazinele din centrele comerciale, in
          reprezentantele din spatii proprii sau cumpara direct de pe site,
          pentru ca vei gasi intotdeauna ceea ce iti promitem: cea mai variata
          gama de produse, super oferte si inovatie constanta!
        </p>
      </>
    ),
  },
  bricostore: {
    title: "Profilul companiei Brico",
    image: [
      {
        path: "https://lcdn.bricostore.ro/LP/ATX/blog/Brico-Header-LP_68a3d1f5.jpg",
        isDefault: true,
      },
    ],
    content: (
      <>
        <h2 className="text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4">
          Istoria Brico in Romania
        </h2>

        <p className="mb-4">
          Brico este un brand de referinta in sectorul bricolajului,
          constructiilor si amenajarilor interioare, oferind solutii eficiente
          pentru proiecte de casa si gradina. Prezent pe piata din Romania din
          2013 (initial sub numele Brico Depot), brandul s-a remarcat printr-un
          concept de tip preturi mici zilnic, stocuri mari si produse esentiale
          pentru profesionisti si pasionati de bricolaj.
        </p>
        <p className="mb-4">
          Reteaua a trecut printr-o etapa importanta de transformare si
          consolidare, devenind un jucator cunoscut in randul celor care cauta
          mobilier de gradina, baie sau bucatarie, materiale de constructii,
          unelte, vopsele si alte produse necesare in renovari si proiecte DIY.
        </p>
        <p className="mb-4">
          In mai 2025 Brico Depot a fost preluat de grupul Altex, lider pe piata
          de retail electro-IT din Romania. Aceasta preluare marcheaza inceputul
          unui nou capitol, in care brandul devine Brico, cu obiectivul de a
          extinde gama de produse, serviciile si infrastructura digitala, pentru
          a raspunde mai bine nevoilor clientilor.
        </p>
        <p className="mb-4">
          Astazi, Brico continua sa deserveasca clientii printr-o retea extinsa
          de magazine fizice si prin platforma online bricostore.ro, ramanand un
          partener de incredere pentru mesteri, echipe de constructii, dar si
          pentru cei care isi fac singuri proiectele de renovare.
        </p>

        <h2 className="text-2xl leading-32 md:text-3xl md:leading-42 text-red-brand mb-4">
          Astazi, Brico Romania:
        </h2>
        <p className="mb-4">
          Brico Romania detine 30 de magazine si ofera solutii accesibile pentru
          renovari si constructii, atat pentru clienti individuali, cat si
          profesionisti.
        </p>
        <p className="mb-4">
          Magazinele Brico sunt localizate strategic in marile orase, oferind
          acces facil si consiliere specializata. In plus, platforma online
          bricostore.ro completeaza experienta de cumparare, punand la
          dispozitie informatii clare, oferte actualizate si posibilitatea de a
          comanda produsele dorite direct de acasa sau de pe santier.
        </p>
        <p className="mb-4">
          Prin dezvoltarea retelei, digitalizarea serviciilor si extinderea
          gamei de produse, Brico Romania isi consolideaza pozitia ca partener
          de incredere pentru proiecte de bricolaj si constructii, indiferent
          daca sunt realizate de amatori sau de echipe profesioniste.
        </p>
      </>
    ),
  },
};
